import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=b9f8a716&"
import script from "./UploadCard.vue?vue&type=script&lang=ts&"
export * from "./UploadCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports